import { Crown, Star } from "lucide-react";
import { cn } from "@/lib/cn";

export interface PlanBadgeProps {
  plan: string;
  className?: string;
}

/** Plan tier pill used on Burn rows. Three visual ranks:
 *  - Kiro Pro   → plain violet pill
 *  - Kiro Pro+  → gold crown
 *  - Kiro Power → pink star with glow */
export function PlanBadge({ plan, className }: PlanBadgeProps) {
  const normalized = plan.trim().toLowerCase();
  const isPower = normalized.includes("power");
  const isProPlus =
    !isPower && (normalized.includes("pro+") || normalized.includes("pro plus"));

  if (isPower) {
    return (
      <span
        title={plan}
        className={cn(
          "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
          "border border-[color:var(--color-brand-3)]/40 bg-[color:var(--color-brand-3)]/15 text-[color:var(--color-brand-3)]",
          "shadow-[0_0_10px_-2px_var(--color-brand-3)]",
          className,
        )}
      >
        <Star size={10} className="fill-current" />
        {plan}
      </span>
    );
  }

  if (isProPlus) {
    return (
      <span
        title={plan}
        className={cn(
          "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
          "border border-[color:var(--color-gold-2)]/40 bg-[color:var(--color-gold-2)]/10 text-[color:var(--color-gold-2)]",
          className,
        )}
      >
        <Crown size={10} />
        {plan}
      </span>
    );
  }

  return (
    <span
      title={plan}
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
        "border border-[color:var(--color-brand-1)]/30 bg-[color:var(--color-brand-1)]/10 text-[color:var(--color-brand-1)]",
        className,
      )}
    >
      {plan}
    </span>
  );
}
